import type { IBuilder, ISeller } from '../../types/newbuildingsCompare';

const mockBuilderWithChat: IBuilder = {
  id: 1,
  realtyUserId: 1,
  name: 'Застройщик',
  logoUrl: '',
  chat: {
    enabled: true,
    suggestText: 'Здравствуйте!',
    context: {},
    entityId: '1',
  },
  phone: {
    countryCode: '7',
    code: '495',
    number: '1234567',
  },
};

const mockBuilderWithoutChat: IBuilder = {
  ...mockBuilderWithChat,
  id: 2,
  realtyUserId: 2,
  chat: null,
  phone: {
    countryCode: '7',
    code: '495',
    number: '1111111',
  },
};

const mockAgency: ISeller = {
  realtyUserId: 3,
  name: 'Агентство недвижимости',
  logoUrl: '',
  chat: null,
  phone: {
    countryCode: '7',
    code: '495',
    number: '7654321',
  },
};

export interface IMockNewbuildingContacts {
  newbuildingId: number;
  url: string;
  builders: IBuilder[];
  sellers: ISeller[];
}

export const mockNewbuildingContacts: IMockNewbuildingContacts[] = [
  {
    newbuildingId: 1,
    url: 'https://www.cian.ru/zhiloy-kompleks-badaevskiy-moskva-348843/',
    builders: [mockBuilderWithChat],
    sellers: [mockAgency],
  },
  {
    newbuildingId: 2,
    url: 'https://www.cian.ru/zhiloy-kompleks-simvol-moskva-348844/',
    builders: [mockBuilderWithoutChat],
    sellers: [],
  },
];
